import { Flex, FlexProps } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import ArrowIcon from '@/public/assets/icons/arrow.svg'

export const BackButton = ({ callback, styles }: { callback?: () => void; styles?: FlexProps }) => {
  const router = useRouter()

  return (
    <Flex
      w={10}
      h={10}
      p={2}
      cursor={'pointer'}
      _hover={{ bg: 'ninja.400' }}
      bg={'ninja.500'}
      rounded={'xl'}
      justifyContent={'center'}
      alignItems={'center'}
      transition={'0.2s'}
      {...styles}
      onClick={() => (callback ? callback() : router.back())}
    >
      <ArrowIcon />
    </Flex>
  )
}
